export const schemaDataTypes = [
    'text',
    'numeric(10,2)',
    'integer',
    'boolean',
    'timestamp',
    'date',
    'time',
    'jsonb'
];
//# sourceMappingURL=schemaDataTypes.js.map